import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './clean-components/app/app';
import './index.scss';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <React.StrictMode>
        <Suspense fallback={(<div>Loading</div>)}>
            <App/>
        </Suspense>
    </React.StrictMode>
    ,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
